<template>
  <div class="status-change-procedure-batch-op-roll-state"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="students">
      <template v-if="students.length">
        <div class="header">
          <div class="label">
            <i class="el-icon-s-opportunity"></i>
            <span>选择要操作跟读转正的学生，批量操作不会修改学生的班级</span>
          </div>
        </div>
        <div class="main">
          <div class="main-cont"
               v-loading="committing"
               element-loading-text="数据提交中，请稍等...">
            <DataGrid size="mini"
                      height="auto"
                      resizable
                      row-id="id"
                      show-overflow="title"
                      show-header-overflow="title"
                      :tree-config="{reserve: true, expandAll: true}"
                      :data="students"
                      :row-class-name="getGradeClassName"
                      @checkbox-change="rowSelectionChange"
                      @checkbox-all="rowSelectionChange">
              <DataGridSelectionColumn width="80"
                                       align="center"
                                       fixed="left"
                                       tree-node
                                       :resizable="false"></DataGridSelectionColumn>
              <DataGridColumn title="年级"
                              width="90">
                <template #default="{row, level}">
                  <span>{{row.grade}}</span>
                  <template v-if="level === 0">
                    <span>({{row.children ? row.children.length : 0}})</span>
                  </template>
                </template>
              </DataGridColumn>
              <DataGridColumn title="班级"
                              field="clazz"
                              min-width="140"></DataGridColumn>
              <DataGridColumn title="教学点"
                              field="site"
                              min-width="150"></DataGridColumn>
              <DataGridColumn title="学号"
                              field="regNo"
                              min-width="120"></DataGridColumn>
              <DataGridColumn title="姓名"
                              field="trueName"
                              min-width="100"></DataGridColumn>
              <DataGridColumn title="性别"
                              field="gender"
                              min-width="80"
                              align="center"></DataGridColumn>
              <DataGridColumn title="证件号码"
                              field="idCard"
                              min-width="150"
                              align="center"></DataGridColumn>
              <DataGridColumn title="手机"
                              field="mobilePhone"
                              min-width="140"
                              align="center"></DataGridColumn>
              <DataGridColumn title="准考证号"
                              width="150"
                              align="center"
                              fixed="right">
                <template #default="{row, level}">
                  <template v-if="level > 0">
                    <el-input v-model.trim="row.admissionNo"
                              size="mini"
                              type="text"
                              maxlength="50"
                              placeholder="请填写准考证号"
                              :disabled="!rowSelection.includes(row)"></el-input>
                  </template>
                </template>
              </DataGridColumn>
              <DataGridColumn title="新学号"
                              width="150"
                              align="center"
                              fixed="right">
                <template #default="{row, level}">
                  <template v-if="level > 0">
                    <el-input v-model.trim="row.targetRegNo"
                              size="mini"
                              type="text"
                              maxlength="50"
                              placeholder="请填写学号"
                              :disabled="!rowSelection.includes(row)"></el-input>
                  </template>
                </template>
              </DataGridColumn>
            </DataGrid>
          </div>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">提交操作</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">关闭窗口</el-button>
        </div>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>没有可跟读转正的学生记录</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>批量跟读转正数据加载失败</div>
        <el-button type="text"
                   @click="loadRollState">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import DataGridSelectionColumn from '../../../../../../../../elements/grid/DataGridSelectionColumn'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'StatusChangeProcedureBatchOpRollState',
  components: {
    DataGrid,
    DataGridColumn,
    DataGridSelectionColumn,
    Hint
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      students: null,
      rowSelection: [],
      committing: false
    }
  },
  methods: {
    loadRollState () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/change/procedure/batchOp/rollState',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.students = response.data['students'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    getGradeClassName ({rowLevel}) {
      if (rowLevel === 0) {
        return 'grade-group'
      }
    },
    rowSelectionChange ({selection}) {
      this.rowSelection = selection.filter(item => !item.children)
    },
    handleApply () {
      const rowSelection = this.rowSelection
      if (!rowSelection.length) {
        this.$message.warning('请选择要操作的学生')
        return
      }
      const isValid = rowSelection.every((item, index) => {
        if (!item.admissionNo) {
          this.$message.warning(`请完善操作的第${index + 1}项准考证号`)
          return
        }
        if (!item.targetRegNo) {
          this.$message.warning(`请完善操作的第${index + 1}项新学号`)
          return
        }
        for (let i = 0; i < index; i++) {
          const checkItem = rowSelection[i]
          if (checkItem.targetRegNo === item.targetRegNo) {
            this.$message.warning(`操作的第${index + 1}项新学号出现重复`)
            return
          }
        }
        return true
      })
      if (!isValid) {
        return
      }
      this.$confirm('确定要提交批量跟读转正操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/status/change/procedure/batchOp/submitRollState',
          method: 'post',
          data: this.$qs.stringify({
            rollState: JSON.stringify({
              changes: rowSelection.map(item => {
                return {
                  id: item.id,
                  admissionNo: item.admissionNo,
                  targetRegNo: item.targetRegNo
                }
              })
            })
          })
        }).then((response) => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.loadRollState()
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadRollState()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadRollState()
      }
    }
  }
}
</script>

<style lang="scss">
  .status-change-procedure-batch-op-roll-state {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 12px 15px;
      & > .label {
        font-size: 12px;
        font-weight: bold;
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .vxe-table {
          border: none!important;
          &:before,
          &:after {
            display: none;
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                &.grade-group {
                  .vxe-body--column {
                    .vxe-cell {
                      font-weight: bold;
                    }
                  }
                }
                .vxe-body--column {
                  .vxe-cell {
                    .vxe-cell--tree-node {
                      .vxe-tree--btn-wrapper {
                        .vxe-tree--node-btn {
                          color: #606266;
                          font-size: 13px;
                          &:hover {
                            color: #303133;
                          }
                        }
                      }
                      .vxe-tree-cell {
                        padding-left: 0!important;
                      }
                    }
                    .el-input {
                      .el-input__inner {
                        text-align: center;
                      }
                    }
                  }
                }
              }
            }
          }
          .vxe-table--fixed-left-wrapper {
            box-shadow: none;
            &.scrolling--middle {
              border-right: 1px solid rgba(0,0,0,.05);
            }
          }
          .vxe-table--fixed-right-wrapper {
            &.scrolling--middle {
              border-left: 1px solid rgba(0,0,0,.05);
              box-shadow: -2px 0 2px rgba(0,0,0,.05);
            }
          }
          .vxe-table--border-line {
            display: none;
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
